import { WorkspaceProfilePicture } from './WorkspaceProfilePicture'
import { ClientOutputs } from '@botpress/client'
import { useWorkspaces } from '~/hooks'
import { PlanBadge } from '~/components/PlanBadge'
import { MembersPreview } from '~/features/home/components/MembersPreview'

export const WorkspaceSocialHeader = ({ workspace }: { workspace: ClientOutputs['getPublicWorkspace'] }) => {
  const activeWorkspace = useWorkspaces().data?.find((w) => w.id === workspace.id)
  const plan = activeWorkspace?.plan
  return (
    <div className="flex items-center gap-3 sm:gap-5">
      <WorkspaceProfilePicture
        workspaceId={workspace.id}
        pictureUrl={workspace.profilePicture}
        className="h-16 w-16 rounded-[10px]"
      />
      <div className="flex flex-grow flex-col gap-1">
        <h3 className="text-base font-bold md:text-lg lg:text-xl">{workspace.name}</h3>
        {plan && (
          <div className="flex items-center gap-1 sm:gap-2">
            <PlanBadge plan={plan} />
            <div className="md:hidden">
              <MembersPreview workspaceId={workspace.id} count={3} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
